import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {connect} from 'react-redux'
import PrivateRoute from './private.route';
import NormalRoute from './normal.route';
import Loader from '../../app/components/loader/loader';
import ShortReport from '../../applications/report/components/short.report.template/short.report.template';

const HomeScreen = React.lazy(() => import('../screens/home/home.screen'));
const AuthScreen = React.lazy(() => import('../../applications/auth/screens/auth.screen/auth.screen'));
const ResetPasswordScreen = React.lazy(() => import('../../applications/auth/screens/reset.password.screen/reset.password.screen'));
const SaatmDashboard = React.lazy(() => import('../../applications/saatmDashboard/screens/saatmDashboard'));
const YDSystemDashboard = React.lazy(() => import('../../applications/ydMonitoring/screens/ydMonitoringDashboard'));
const AdminDashboard = React.lazy(() => import('../../applications/adminDashboard/screens/adminDashboard/adminDashboard'));
const Profile = React.lazy(() => import('../../applications/auth/screens/profile.screen/profile.screen'));
const Help = React.lazy(() => import('../../applications/help/screens/help'));
const ELibrary = React.lazy(() => import('../../applications/ELibrary/screens/eLibrary'));
const Definitions = React.lazy(() => import('../../applications/ELibrary/screens/definitions'));
const Reports = React.lazy(() => import('../../applications/report/screens/report'));
const Comments = React.lazy(() => import('../components/add.comment/add.comment'));
const Contact = React.lazy(() => import('../../applications/help/screens/contact'));
const Documents = React.lazy(() => import('../../applications/Documents/screens/documents'));



/**
 * @description this is the main routes for the main application src/app. 
 */
const Routes = ({loading_current_user}) => {

    if (loading_current_user) return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column'}}>
            <Loader />
            <p>Loading...</p>
        </div>
    )

    return (
        <Suspense fallback={<Loader />}>
            <Switch>
                <PrivateRoute path={"/yd-monitoring"} pageTitle="YD Monitoring System">
                    <Route
                        exact
                        component={props => <YDSystemDashboard {...props} />}
                        path={"/yd-monitoring"} />
                </PrivateRoute>
                
                <PrivateRoute path={"/saatm-dashboard"} pageTitle="SAATM Dashboard">
                    <Route
                        exact
                        component={props => <SaatmDashboard {...props} />}
                        path={"/saatm-dashboard"} />
                </PrivateRoute>

                <PrivateRoute path={"/profile"} pageTitle="Profile Settings">
                    <Route
                        exact
                        component={props => <Profile {...props} />}
                        path={"/profile"} />
                </PrivateRoute>

                <PrivateRoute path={"/administration"} pageTitle="Admin Dashboard">
                    <Route
                        exact
                        component={props => <AdminDashboard {...props} />}
                        path={"/administration"} />
                </PrivateRoute>

                <PrivateRoute path={"/help"} pageTitle="Help & Support">
                    <Route
                        exact
                        component={props => <Help {...props} />}
                        path={"/help"} />
                </PrivateRoute>

                <PrivateRoute path={"/e-library"} pageTitle="YD Regulations">
                    <Route
                        exact
                        component={props => <ELibrary {...props} />}
                        path={"/e-library"} />
                </PrivateRoute>

                <PrivateRoute path={"/definitions"} pageTitle="Definitions">
                    <Route
                        exact
                        component={props => <Definitions {...props} />}
                        path={"/definitions"} />
                </PrivateRoute>

                <PrivateRoute path={"/documents"} pageTitle="Documents">
                    <Route
                        exact
                        component={props => <Documents {...props} />}
                        path={"/documents"} />
                </PrivateRoute>

                <PrivateRoute path={"/reports"} pageTitle="Reports">
                    <Route
                        exact
                        component={props => <Reports {...props} />}
                        path={"/reports"} />
                </PrivateRoute>

                <PrivateRoute exact path={"/short-reports"} pageTitle="Short Reports">
                    <Route
                        exact
                        component={props => <ShortReport {...props} />}
                        path={"/short-reports"} />
                </PrivateRoute>

                <PrivateRoute path={"/comments"} pageTitle="Comments">
                    <Route
                        exact
                        component={props => <Comments {...props} />}
                        path={"/comments"} />
                </PrivateRoute>

                <PrivateRoute path={"/contact"} pageTitle="Contact">
                    <Route
                        exact
                        component={props => <Contact {...props} />}
                        path={"/contact"} />
                </PrivateRoute>
                
                <Route
                    exact
                    path={'/'}
                    component={props => <HomeScreen {...props} />}
                />
                <Route
                    exact
                    path={'/auth'}
                    component={props => <AuthScreen {...props} />}
                />
                <Route
                    exact
                    path={'/reset-password'}
                    component={props => <ResetPasswordScreen {...props} />}
                />
                <Redirect from="/register" to="/auth" />
            </Switch>
        </Suspense>)
}

const mapStateToProps = ({AuthReducer}) =>({
    loading_current_user: AuthReducer.loading_current_user
});

export default connect(mapStateToProps)(Routes);
